import { render, staticRenderFns } from "./Autorizador.vue?vue&type=template&id=090c0540&scoped=true"
import script from "./Autorizador.vue?vue&type=script&lang=js"
export * from "./Autorizador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c0540",
  null
  
)

export default component.exports